import { render, staticRenderFns } from "./SimpleTableList.vue?vue&type=template&id=6646ff7a&scoped=true&"
import script from "./SimpleTableList.vue?vue&type=script&lang=js&"
export * from "./SimpleTableList.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTableList.vue?vue&type=style&index=0&id=6646ff7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646ff7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6646ff7a')) {
      api.createRecord('6646ff7a', component.options)
    } else {
      api.reload('6646ff7a', component.options)
    }
    module.hot.accept("./SimpleTableList.vue?vue&type=template&id=6646ff7a&scoped=true&", function () {
      api.rerender('6646ff7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/widgets/SimpleTableList.vue"
export default component.exports